<mat-card class="example-card">
  <mat-card-header class="card-header">
    <mat-card-title class="card-titulo">Detalle de {{'Movimiento' | translate}}</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content style="margin-bottom: 0%;">

    <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label class="text-style" *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="canView && !isSearching && item != null">

      <!--SELECCION PAGO O DEUDA-->
      <mat-expansion-panel [expanded]="true" *ngIf="canAddPago || canAddDeuda" style="margin-bottom: 1%;">

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin-top: 10px;">

          <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="text-align: center; margin-bottom: 8px;">
            <mat-label style="font-weight: bold; font-size: 16px;">¿Qué operación queres realizar?</mat-label>
          </div>

          <br />

          <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item">

            <div fxLayout="row stretch" fxLayout.xs="column">

              <ng-container *ngIf="canAddPago">

                <button mat-raised-button (click)="onPagoClick(true)"  [disabled]="isSaving"
                  class="zb-button" [ngStyle]="{ 'background-color': verVersionSimplificada && operacion === 1 ? '#ffd000' : '#fff'}">
                  {{'MovimientoPago' | translate}} {{isRosbaco ? '' : 'Simplificado'}}
                </button>
                <button mat-raised-button (click)="onPagoClick(false)" [disabled]="isSaving" *ngIf="!isRosbaco"
                  class="zb-button" [ngStyle]="{ 'background-color': !verVersionSimplificada && operacion === 1 ? '#ffd000' : '#fff'}">
                  {{'MovimientoPago' | translate}}
                </button>

              </ng-container>

              <ng-container *ngIf="canAddDeuda">

                <button mat-raised-button (click)="onDeudaClick(false)" [disabled]="isSaving" *ngIf="!isRosbaco"
                  class="zb-button" [ngStyle]="{ 'background-color': !verVersionSimplificada && operacion < 0 ? '#ffd000' : '#fff'}">
                  {{'MovimientoDeuda' | translate}}
                </button>
                <button mat-raised-button (click)="onDeudaClick(true)" [disabled]="isSaving"
                  class="zb-button" [ngStyle]="{ 'background-color': verVersionSimplificada && operacion < 0 ? '#ffd000' : '#fff'}">
                  {{'MovimientoDeuda' | translate}} {{isRosbaco ? '' : 'Simplificada'}}
                </button>

              </ng-container>

            </div>

          </div>

        </div>

      </mat-expansion-panel>

      <!--SELECCION DE DEUDAS A SALDAR-->
      <ng-container *ngIf="canAddPago && operacion > 0 && !verVersionSimplificada">

        <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

          <mat-expansion-panel-header>
            <mat-panel-title class="card-subtitulo">
              <mat-icon style="margin-top: -3px;">playlist_add_check</mat-icon> Deudas a Saldar
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <!-- ESTADISTICAS -->
          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=40 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Forma de saldar deudas</mat-label>
                <mat-select [(ngModel)]="saldoModoSeleccionado" (selectionChange)="onSaldoModoChange()">
                  <mat-option *ngFor="let s of saldoModosList" [value]="s.Id">
                    {{s.Nombre}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=30 fxFlex.xs=100 fxFlexLayout="center center" class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: rgb(128, 202, 128);">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Disponible</b>: {{formGroup.controls['Moneda']?.value?.Codigo}} {{totalDisponible | number: '1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=30 fxFlex.xs=100 fxFlexLayout="center center" class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: indianred;">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Total a Pagar</b>: {{formGroup.controls['Moneda']?.value?.Codigo}} {{totalPorPagar | number: '1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

          <!--BUSCADOR DE DEUDAS-->
          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-expansion-panel *ngIf="!isMovimientoDeudaSearching">

                <mat-expansion-panel-header style="background-color: #ffd000BB;">
                  <mat-panel-title>
                    <mat-icon style="margin-top: -3px;">search</mat-icon> ¿Queres refinar la búsqueda de las deudas pendientes?
                  </mat-panel-title>
                  <mat-panel-description>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <form [formGroup]="searchDeudaForm">

                  <div fxLayout="row stretch" fxLayout.xs="column">

                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label class="text-style" *ngIf="!isMonedaSearching">Moneda</mat-label>
                        <mat-label class="text-style" *ngIf="isMonedaSearching">Cargando...</mat-label>
                        <mat-select class="text-style" formControlName="MonedaId">
                          <mat-option class="text-style">Todas</mat-option>
                          <mat-option class="text-style" *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%" >
                        <mat-label class="text-style">Fecha Movimiento Desde</mat-label>
                        <input class="text-style" matInput [matDatepicker]="fechaMovimientoDesdePicker" formControlName="FechaMovimientoDesde"  (click)="fechaMovimientoDesdePicker.open()">
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoDesdePicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDeudaDate('FechaMovimientoDesde')">
                          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #fechaMovimientoDesdePicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label class="text-style">Fecha Movimiento Hasta</mat-label>
                        <input class="text-style" matInput [matDatepicker]="fechaMovimientoHastaPicker" formControlName="FechaMovimientoHasta"  (click)="fechaMovimientoHastaPicker.open()">
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoHastaPicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDeudaDate('FechaMovimientoHasta')">
                          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #fechaMovimientoHastaPicker></mat-datepicker>
                      </mat-form-field>
                    </div>

                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Detalle</mat-label>
                        <input matInput formControlName="Detalle" (keyup.enter)="searchGastosPendientes()">
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%" >
                        <mat-label class="text-style">Fecha Vencimiento Desde</mat-label>
                        <input class="text-style" matInput [matDatepicker]="fechaVencimientoDesdePicker" formControlName="FechaVencimientoDesde"  (click)="fechaVencimientoDesdePicker.open()">
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoDesdePicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDeudaDate('FechaVencimientoDesde')">
                          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #fechaVencimientoDesdePicker></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label class="text-style">Fecha Vencimiento Hasta</mat-label>
                        <input class="text-style" matInput [matDatepicker]="fechaVencimientoHastaPicker" formControlName="FechaVencimientoHasta"  (click)="fechaVencimientoHastaPicker.open()">
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoHastaPicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDeudaDate('FechaVencimientoHasta')">
                          <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #fechaVencimientoHastaPicker></mat-datepicker>
                      </mat-form-field>
                    </div>

                    <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlPedidos || tenantFeatureFlags?.HabilitarControlContratos">

                      <hr width="100%" style="margin: 5px 0px;">

                      <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlPedidos">
                        <mat-form-field appearance="outline" style="width: 100%">
                          <mat-label>Nro. Pedido</mat-label>
                          <input matInput formControlName="PedidoId" type="number" (keyup.enter)="onSearch()">
                          <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                      </div>
                      <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlContratos">
                        <mat-form-field appearance="outline" style="width: 100%">
                          <mat-label>Cód. Contrato</mat-label>
                          <input matInput formControlName="Contrato" (keyup.enter)="onSearch()">
                          <mat-icon matSuffix>search</mat-icon>
                        </mat-form-field>
                      </div>

                    </ng-container>

                    <hr width="100%" style="margin: 5px 0px;">

                    <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label *ngIf="!isConsorcioSearching">{{'Consorcio' | translate}}</mat-label>
                        <mat-label *ngIf="isConsorcioSearching">Cargando...</mat-label>
                        <mat-select formControlName="ConsorcioId">
                          <mat-option>Todos</mat-option>
                          <mat-option *ngFor="let s of consorcioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                        <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                        <mat-select formControlName="ComunidadId" (selectionChange)="onDeudaFiltroUfComunidadSelect()">
                          <mat-option>Todos</mat-option>
                          <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionUf">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label *ngIf="!isUnidadesFuncionalesSearching">{{ 'UnidadFuncional' | translate}}</mat-label>
                        <mat-label *ngIf="isUnidadesFuncionalesSearching">Cargando...</mat-label>
                        <mat-select formControlName="UnidadFuncionalId">
                          <mat-option>Ninguna</mat-option>
                          <mat-option *ngFor="let s of ufList" [value]="s.Id">{{s.Codigo}}</mat-option>
                        </mat-select>
                      </mat-form-field>

                    </div>

                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <input type="text" placeholder="Proveedor" aria-label="Proveedor" matInput
                          [matAutocomplete]="proveedor" formControlName="Proveedor">
                        <i [ngStyle]="{'display': isProveedorAutoSearching ? 'inline-block' : 'none'}"
                          class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                      </mat-form-field>
                      <mat-autocomplete #proveedor="matAutocomplete" [displayWith]="displayProveedor">
                        <mat-option *ngFor="let s of filteredProveedorList" [value]="s">
                          {{s.RazonSocial }}
                        </mat-option>
                      </mat-autocomplete>

                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Usuario</mat-label>
                        <input matInput formControlName="Usuario" (keyup.enter)="onSearch()">
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Nro. Documento</mat-label>
                        <input matInput formControlName="NroDocumento" (keyup.enter)="onSearch()">
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>

                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="MailContacto" (keyup.enter)="onSearch()">
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                      <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label>Nro. Celular</mat-label>
                        <input matInput formControlName="MovilContacto" (keyup.enter)="onSearch()">
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </div>
                    <div fxFlex=33 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;"  *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
                      <mat-checkbox formControlName="VerSoloAsociadosAUfs">
                        Ver solo {{'MovimientoDeuda' | translate}} de {{'UnidadFuncional' | translate}}
                      </mat-checkbox>
                    </div>

                  </div>

                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <button mat-raised-button (click)="searchGastosPendientes()" [disabled]="isMovimientoDeudaSearching" color="primary" class="zb-button">
                      {{isMovimientoDeudaSearching ? 'Buscando...' : 'Buscar Deudas'}}
                    </button>
                  </div>

                </form>

              </mat-expansion-panel>

            </div>

          </div>

          <!--GRILLA DE DEUDAS-->
          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-expansion-panel [expanded]="true" hideToggle="false">

                <div fxLayout="row stretch" class="zb-readonly" style="margin-top: 15px;">

                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                    <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isMovimientoDeudaSearching">
                      <mat-label class="text-style"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
                    </div>
                    <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isMovimientoDeudaSearching">

                      <ng-container *ngIf="esIngresoManual()">
                        <ejs-grid #deudasPendientesGrid [dataSource]='deudasPendientesList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
                          [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' [contextMenuItems]='contextMenuItems'
                          (contextMenuClick)='contextMenuClick($event)' (contextMenuOpen)='contextMenuOpen($event)'>
                          <e-columns>
                            <e-column type="checkbox" width="40" [visible]="!esIngresoManual()"></e-column>
                            <e-column field='FechaMovimiento' headerText='Fecha Movimiento' width=80 type='date' format="dd/MM/yyyy">
                              <ng-template #template let-data>
                                {{data.FechaMovimiento | date:'dd/MM/yyyy'}}
                              </ng-template>
                            </e-column>
                            <e-column field='FechaVencimiento' headerText='Vencimiento' width=80 type='date' format="dd/MM/yyyy">
                              <ng-template #template let-data>
                                {{data.FechaVencimiento | date:'dd/MM/yyyy'}}
                              </ng-template>
                            </e-column>
                            <e-column field='CuentaImputada' headerText='Referencia' width=90></e-column>
                            <e-column field='Detalle' headerText='Detalle' width=120></e-column>
                            <e-column field='TipoMovimientoNombre' headerText='Tipo' width=70></e-column>
                            <e-column field='Monto' headerText='Total' width=80 format="N2" textAlign='Right'>
                              <ng-template #template let-data>
                                {{data.Moneda}} {{data.Monto | number:'1.2-2'}}
                              </ng-template>
                            </e-column>
                            <e-column field='Saldo' headerText='Pendiente' width=90 format="N2" textAlign='Right'>
                              <ng-template #template let-data>
                                {{data.Moneda}} {{data.Saldo | number:'1.2-2'}}
                              </ng-template>
                            </e-column>
                            <e-column field='SaldoConvertido' eaderText='Saldo Convertido' width=90 format="N2" textAlign='Right'>
                              <ng-template #template let-data>
                                {{formGroup.controls['Moneda']?.value?.Codigo}} {{data.SaldoConvertido | number:'1.2-2'}}
                              </ng-template>
                            </e-column>
                            <e-column field='MontoPago' headerText='Monto a Pagar' width=90 [visible]="esIngresoManual()">
                              <ng-template #template let-data>
                                <input matInput type="number" [(ngModel)]="data.MontoPago" name="MontoPago" maxlength="30"
                                  (change)="onDeudaGridFieldChange(data.Id, data.MontoPago)" style="padding:5px; width: 80%; border: 1px black solid; text-align: left;">
                              </ng-template>
                            </e-column>
                          </e-columns>
                        </ejs-grid>
                      </ng-container>

                      <ng-container *ngIf="!esIngresoManual()">
                        <ejs-grid #deudasPendientesGrid [dataSource]='deudasPendientesList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
                          [selectionSettings]='deudaSelectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' (rowSelected)='onDeudaRowSelect($event)'
                          (rowDeselected)="onDeudaRowDeselected($event)" (dataBound)='onDeudaDataBound($event)'>
                          <e-columns>
                            <e-column type="checkbox" width="40"></e-column>
                            <e-column field='FechaMovimiento' headerText='Fecha Movimiento' width=80 type='date' format="dd/MM/yyyy">
                              <ng-template #template let-data>
                                {{data.FechaMovimiento | date:'dd/MM/yyyy'}}
                              </ng-template>
                            </e-column>
                            <e-column field='FechaVencimiento' headerText='Vencimiento' width=80 type='date' format="dd/MM/yyyy">
                              <ng-template #template let-data>
                                {{data.FechaVencimiento | date:'dd/MM/yyyy'}}
                              </ng-template>
                            </e-column>
                            <e-column field='CuentaImputada' headerText='Referencia' width=90></e-column>
                            <e-column field='Detalle' headerText='Detalle' width=120></e-column>
                            <e-column field='TipoMovimientoNombre' headerText='Tipo' width=70></e-column>
                            <e-column field='Monto' headerText='Total' width=80 format="N2" textAlign='Right'>
                              <ng-template #template let-data>
                                {{data.Moneda}} {{data.Monto | number:'1.2-2'}}
                              </ng-template>
                            </e-column>
                            <e-column field='Saldo' headerText='Pendiente' width=90 format="N2" textAlign='Right'>
                              <ng-template #template let-data>
                                {{data.Moneda}} {{data.Saldo | number:'1.2-2'}}
                              </ng-template>
                            </e-column>
                            <e-column headerText='Saldo Convertido' width=90 format="N2" textAlign='Right'>
                              <ng-template #template let-data>
                                {{formGroup.controls['Moneda']?.value?.Codigo}} {{data.SaldoConvertido | number:'1.2-2'}}
                              </ng-template>
                            </e-column>
                          </e-columns>
                        </ejs-grid>
                      </ng-container>

                    </div>

                  </div>

                </div>

              </mat-expansion-panel>

            </div>

          </div>

        </mat-expansion-panel>

      </ng-container>

      <!--DATOS DE MOVIMIENTO-->
      <ng-container *ngIf="showStep1">

        <!--SOLO LECTURA-->
        <ng-container *ngIf="!canAddPago && !canAddDeuda">

          <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

            <mat-expansion-panel-header>
              <mat-panel-title class="card-subtitulo">
                <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos de Movimiento
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Fecha de Movimiento</b>: {{item?.FechaMovimiento | date:'dd/MM/yyyy HH:mm:ss'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Tipo de Movimiento</b>: {{item?.TipoMovimiento}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Detalle</b>: {{item?.Detalle}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Moneda</b>: {{item?.Moneda}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Importe</b>: {{item?.Monto | number: '1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Medio de Pago</b>: {{item?.MedioPagoNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Estado</b>: {{item?.Estado}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="!canAddPago && !canAddDeuda">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Observación</b>: {{item?.Observacion}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="item?.AdjuntoUrl != null && item?.AdjuntoUrl.length > 0">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <a href="{{item?.AdjuntoUrl}}" target="_blank">Ver archivo adjunto</a>
                  </div>
                </mat-expansion-panel>
              </div>

            </div>

          </mat-expansion-panel>

        </ng-container>

        <form [formGroup]="formGroup" *ngIf="canAddPago || canAddDeuda">

          <!-- DATOS DEL MOVIMIENTO -->
          <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

            <mat-expansion-panel-header>
              <mat-panel-title class="card-subtitulo">
                <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos de Movimiento
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <!-- ANALISIS DE ARCHIVO -->
            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="canAnalizarDoc">

              <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item">

                <mat-expansion-panel [expanded]="true" hideToggle="true" style="background-color: #d0eeff;">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style" style="font-weight: bold; text-align: center;">
                      ¿Queres cargar los datos del {{('Movimiento' | translate).toLowerCase()}} automáticamente desde un archivo?
                    </mat-label>
                  </div>

                  <div fxLayout="row stretch" fxLayout.xs="column" style="text-align: center;">
                    <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item">
                      <button mat-icon-button matSuffix (click)="adjuntoAnalisisInput.click()" *ngIf="!isFileAttaching && !isFileAnalyzing" style="width: 100%;">
                        <mat-icon style="margin-right: 5px;">attach_file</mat-icon> Analizalo acá.
                      </button>
                      <input hidden (change)="onFileAttachForAnalyze($event)" #adjuntoAnalisisInput type="file">
                      <mat-label *ngIf="isFileAttaching"><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...</mat-label>
                      <mat-label *ngIf="isFileAnalyzing"><i class="fa fa-spinner fa-spin"></i> Analizando archivo...</mat-label>
                    </div>
                  </div>
                </mat-expansion-panel>

              </div>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <!-- Fecha de Movimiento + Tipo de Movimiento -->
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label>Fecha de Movimiento*</mat-label>
                  <input matInput [matDatepicker]="fechaMovimientoPicker" formControlName="FechaMovimiento"  (click)="fechaMovimientoPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaMovimientoPicker></mat-datepicker>
                  <mat-error *ngIf="!formGroup.controls['FechaMovimiento'].valid && formGroup.controls['FechaMovimiento'].touched">
                    {{ getErrorFechaMovimiento() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoMovimientoSearching">Tipo de Movimiento*</mat-label>
                  <mat-label *ngIf="isTipoMovimientoSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoMovimientoId">
                    <mat-option *ngFor="let s of tipoMovimientoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['TipoMovimientoId'].valid && formGroup.controls['TipoMovimientoId'].touched">
                    {{ getErrorTipoMovimientoId() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Estado + Fecha Vencimiento -->
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="canChangeState && !verVersionSimplificada">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isEstadoSearching">Estado*</mat-label>
                  <mat-label *ngIf="isEstadoSearching">Cargando...</mat-label>
                  <mat-select formControlName="EstadoId">
                    <mat-option *ngFor="let s of estadoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['EstadoId'].valid && formGroup.controls['EstadoId'].touched">
                    {{ getErrorEstadoId() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="operacion < 0 || (operacion > 0 && esEstadoPendiente())">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label>Fecha Vencimiento*</mat-label>
                  <input matInput [matDatepicker]="fechaVencimientoPicker" formControlName="FechaVencimiento"  (click)="fechaVencimientoPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaVencimientoPicker></mat-datepicker>
                  <mat-error *ngIf="!formGroup.controls['FechaVencimiento'].valid && formGroup.controls['FechaVencimiento'].touched">
                    {{ getErrorFechaVencimiento() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Detalle -->
              <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="width: 100%">
                <mat-form-field appearance="outline" style="width: 100%" >
                  <mat-label>Detalle*</mat-label>
                  <input matInput formControlName="Detalle" maxlength="100" (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!formGroup.controls['Detalle'].valid && formGroup.controls['Detalle'].touched">
                    {{ getErrorDetalle() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Nro de Comprobante -->
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="!verVersionSimplificada">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nro. Comprobante</mat-label>
                  <input matInput formControlName="NroComprobante" (keyup.enter)="onGuardar()" maxlength="100">
                  <mat-error *ngIf="!formGroup.controls['NroComprobante'].valid && formGroup.controls['NroComprobante'].touched">
                    {{ getErroNroComprobante() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Observacion -->
              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <!-- <mat-expansion-panel [expanded]="true" hideToggle="true"> -->
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label class="text-style">Observación</mat-label>
                    <textarea matInput formControlName="Observacion" maxlength="300"></textarea>
                    <mat-error *ngIf="!formGroup.controls['Observacion'].valid && formGroup.controls['Observacion'].touched">
                      {{ getErrorObservacion() }}
                    </mat-error>
                  </mat-form-field>
                <!-- </mat-expansion-panel> -->
              </div>

            </div>

            <ng-container *ngIf="operacion > 0 && !verVersionSimplificada">

              <hr style="margin: 10px 0px; width: 100%;">

              <!-- Medio Pago + Seleccion Cuenta Credito-->
              <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isMedioPagoSearching">Medio de Pago*</mat-label>
                    <mat-label *ngIf="isMedioPagoSearching">Cargando...</mat-label>
                    <mat-select formControlName="MedioPagoId" (selectionChange)="onMedioPagoSelect()">
                      <mat-option *ngFor="let s of medioPagoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!formGroup.controls['MedioPagoId'].valid && formGroup.controls['MedioPagoId'].touched">
                      {{ getErrorMedioPagoId() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="debeSeleccionarCuentaImputada" style="margin-top: 10px;">
                  <!-- <mat-expansion-panel [expanded]="true" hideToggle="true"> -->
                    <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                      <button mat-raised-button (click)="openDialogCuentaCreditoSearch()" [disabled]="isProcessing()" color="primary" class="zb-button">
                        <mat-icon style="margin-right: 3px;">search</mat-icon>Buscar Cuenta con Crédito
                      </button>
                      <button mat-raised-button (click)="cleanCuentaImputada()" *ngIf="cuentaImputada != null" [disabled]="isProcessing()"
                        style="margin-left: 3px;" color="warn" class="zb-button" title="Limpiar cuenta seleccionada">
                        <mat-icon style="margin-right: 3px;">delete_forever</mat-icon>
                      </button>
                    </div>
                  <!-- </mat-expansion-panel> -->
                </div>

              </div>

              <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="debeSeleccionarCuentaImputada">

                <ng-container *ngIf="cuentaImputada != null">

                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="cuentaImputada.Codigo != null && cuentaImputada.Codigo.length > 0">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label class="text-label"><b>Código </b>: {{cuentaImputada.Codigo}}</mat-label>
                      </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!(cuentaImputada.Codigo != null && cuentaImputada.Codigo.length > 0)">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label class="text-label">
                          <b>Código </b>:
                          <span *ngIf="cuentaImputada.PersonaNombre != null && cuentaImputada.PersonaNombre?.length > 0">{{cuentaImputada.PersonaNombre}}</span>
                          <span *ngIf="cuentaImputada.Proveedor != null && cuentaImputada.Proveedor?.length > 0">{{cuentaImputada.Proveedor}}</span>
                          <span *ngIf="cuentaImputada.Comunidad != null && cuentaImputada.Comunidad?.length > 0">{{cuentaImputada.Comunidad}}</span>
                          <span *ngIf="cuentaImputada.Consorcio != null && cuentaImputada.Consorcio?.length > 0">{{cuentaImputada.Consorcio}}</span>
                          <span *ngIf="cuentaImputada.UnidadFuncional != null && cuentaImputada.UnidadFuncional?.length > 0">{{cuentaImputada.UnidadFuncional}}</span>
                        </mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label class="text-label" *ngIf="iscuentaImputadaSearching"><i class="fa fa-spinner fa-spin"></i></mat-label>
                        <mat-label class="text-label" *ngIf="!iscuentaImputadaSearching"><b>Saldo Disponible</b>: {{cuentaImputadaSaldo?.Moneda}} {{cuentaImputadaSaldo?.Saldo | number:'1.2-2'}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>

                  <ng-container *ngIf="cuentaImputada.Id > 0 && !cuentaImputada.EsCuentaCorrienteInterna">

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-label"><b>CBU/CVU</b>: {{cuentaImputada.ClaveBancaria}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-label"><b>Alias</b>: {{cuentaImputada.Alias}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-label"><b>Banco</b>: {{cuentaImputada.BancoNombre}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-label"><b>Número de Cuenta</b>: {{cuentaImputada.NumeroCuenta}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-label"><b>Titular</b>: {{cuentaImputada.Titular}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                  </ng-container>

                </ng-container>

              </div>

            </ng-container>

            <hr style="margin: 10px 0px; width: 100%;">

            <!-- Moneda + Importe Base -->
            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isMonedaSearching">Moneda*</mat-label>
                  <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                  <mat-select formControlName="Moneda" (selectionChange)="onMonedaSelect()">
                    <mat-option *ngFor="let s of monedaList" [value]="s">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['Moneda'].valid && formGroup.controls['Moneda'].touched">
                    {{ getErrorMonedaId() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Importe*</mat-label>
                  <input matInput type="number" formControlName="MontoBase" (change)="onMontoBaseChange()" (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!formGroup.controls['MontoBase'].valid && formGroup.controls['MontoBase'].touched">
                    {{ getErrorMontoBase() }}
                  </mat-error>
                </mat-form-field>
              </div>

            </div>

            <!-- Alicuota IVA -->
            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="operacion === -1">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isAlicuotaIvaSearching">IVA*</mat-label>
                  <mat-label *ngIf="isAlicuotaIvaSearching">Cargando...</mat-label>
                  <mat-select formControlName="AlicuotaIvaId" (selectionChange)="onAlicuotaIvaSelect()">
                    <mat-option *ngFor="let s of alicuotaIvaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['AlicuotaIvaId'].valid && formGroup.controls['AlicuotaIvaId'].touched">
                    {{ getErrorAlicuotaIvaId() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="operacion === -1">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Importe IVA</b>: {{montoIva | number:'1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

            </div>

            <!-- Importe Percepciones y Total -->
            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="!verVersionSimplificada">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Importe Percepciones/Retenciones*</mat-label>
                  <input matInput type="number" formControlName="MontoPercepciones" (change)="calcularMontos()" (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!formGroup.controls['MontoPercepciones'].valid && formGroup.controls['MontoPercepciones'].touched">
                    {{ getErrorMontoPercepciones() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Importe Total</b>: {{montoTotal | number:'1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

            </div>

            <!-- Movimientos Recurrentes -->
            <ng-container *ngIf="!(operacion > 0) && canRecurrentes && !verVersionSimplificada">

              <hr style="margin: 10px 0px; width: 100%;">

              <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

                <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;">
                  <mat-checkbox formControlName="EsRecurrente" (keyup.enter)="onGuardar()" color="primary">¿Es un movimiento recurrente?</mat-checkbox>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="formGroup?.get('EsRecurrente')?.value == true">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Periodicidad de Recurrencia (días)*</mat-label>
                    <input matInput type="number" formControlName="PeriodicidadRecurrencia" (keyup.enter)="onGuardar()" maxlength="10">
                    <!-- <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                      {{ getErrorNombre() }}
                    </mat-error> -->
                  </mat-form-field>
                </div>

              </div>

            </ng-container>

          </mat-expansion-panel>

          <!-- Configuracion de cuotas -->
          <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;" *ngIf="!(operacion > 0) && !verVersionSimplificada">

            <mat-expansion-panel-header>
              <mat-panel-title class="card-subtitulo">
                <mat-icon style="margin-top: -3px;">attach_money</mat-icon> Configuración de Formas de Pago
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Cantidad de Cuotas*</mat-label>
                  <input matInput type="number" formControlName="CantidadCuotas" (change)="calcularMontos()" (keyup.enter)="onGuardar()">
                  <mat-error *ngIf="!formGroup.controls['CantidadCuotas'].valid && formGroup.controls['CantidadCuotas'].touched">
                    {{ getErrorCantidadCuotas() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <ng-container *ngIf="(formGroup?.controls['CantidadCuotas']?.value > 1)">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%" >
                    <mat-label>Fecha de Inicio de Cuota*</mat-label>
                    <input matInput [matDatepicker]="fechaInicioCuotaPicker" formControlName="FechaInicioCuota"  (click)="fechaInicioCuotaPicker.open()">
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaInicioCuotaPicker">
                    </mat-datepicker-toggle>
                    <mat-datepicker #fechaInicioCuotaPicker></mat-datepicker>
                    <mat-error *ngIf="!formGroup.controls['FechaInicioCuota'].valid && formGroup.controls['FechaInicioCuota'].touched">
                      {{ getErrorFechaInicioCuota() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Periodicidad de Cuotas (en días)*</mat-label>
                    <input matInput type="number" formControlName="DiasRepeticionCuotas" maxlength="5" (keyup.enter)="onGuardar()">
                    <mat-error *ngIf="!formGroup.controls['DiasRepeticionCuotas'].valid && formGroup.controls['DiasRepeticionCuotas'].touched">
                      {{ getErrorDiasRepeticionCuotas() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Porcentaje de Ajuste*</mat-label>
                    <input matInput type="number" formControlName="PorcentajeAjusteCuota" (change)="calcularMontos()" (keyup.enter)="onGuardar()">
                    <mat-error *ngIf="!formGroup.controls['PorcentajeAjusteCuota'].valid && formGroup.controls['PorcentajeAjusteCuota'].touched">
                      {{ getErrorPorcentajeAjusteCuota() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="(formGroup?.controls['PorcentajeAjusteCuota']?.value > 0)" style="margin-top: 20px;">
                  <mat-checkbox class="text-style" formControlName="AplicarAjusteIncremental" (keyup.enter)="onGuardar()" color="primary">
                    <mat-label style="white-space: normal !important;">Aplicar el porcentaje de ajuste de forma incremental en cada cuota</mat-label>
                  </mat-checkbox>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label class="text-style"><b>Importe Primera Cuota</b>: {{montoCuota | number:'1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

              </ng-container>

            </div>

          </mat-expansion-panel>

          <!--ADJUNTOS EDIT-->
          <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">attach_file</mat-icon> Adjuntos
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngFor="let file of item.Adjuntos" style="margin: 5px;">

              <div fxFlex=30 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Descripción</mat-label>
                  <input matInput [(ngModel)]="file.Descripcion" [ngModelOptions]="{standalone: true}" maxlength="150">
                </mat-form-field>
              </div>
              <div fxFlex=65 fxFlex.xs=95 class="flex-item" style="margin-top: 20px;">
                <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
              </div>
              <div fxFlex=5 fxFlex.xs=5 class="flex-item" style="margin-top: 10px;">
                <button mat-icon-button (click)="onFileAttachedDelete(file)" title="Eliminar adjunto">
                  <i class="fa fa-trash fa-1x"></i>
                </button>
              </div>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=30 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Descripción</mat-label>
                  <input matInput [(ngModel)]="newFileDescripcion" [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </div>
              <div fxFlex=70 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;">
                <button mat-icon-button matSuffix (click)="adjuntoInput.click()" [disabled]="isFileAttaching">
                  <mat-icon style="margin-right: 5px;">attach_file</mat-icon> Agregar adjunto
                </button>
                <input hidden (change)="onNewFileAttach($event)" #adjuntoInput type="file">
                <mat-label *ngIf="isFileAttaching"><br /><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...</mat-label>
              </div>

            </div>

          </mat-expansion-panel>

          <!-- Seccion de deuda con pago asociado (solo aplica para deudas) -->
          <ng-container *ngIf="!(operacion > 0)">

            <br/>

            <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

              <mat-expansion-panel-header>
                <mat-panel-title class="card-subtitulo">
                  <mat-icon style="margin-top: -3px;">money</mat-icon> Configuración de {{('MovimientoPago' | translate).toLowerCase()}}
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

                <div fxFlex=33 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center" style="margin-top: 15px;">
                  <mat-checkbox class="text-style" formControlName="MovimientoPagado" (change)="onMovimientoPagadoChange()" (keyup.enter)="onAccept()" color="primary">
                    Tiene {{('MovimientoPago' | translate).toLowerCase()}} asociado
                  </mat-checkbox>
                </div>

                <ng-container *ngIf="(formGroup?.controls['MovimientoPagado']?.value == true)">

                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label *ngIf="!isTipoMovimientoSearching">Tipo de Movimiento del Pago*</mat-label>
                      <mat-label *ngIf="isTipoMovimientoSearching">Cargando...</mat-label>
                      <mat-select formControlName="TipoMovimientoPagoId">
                        <mat-option *ngFor="let s of tipoMovimientoPagoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label>Monto Pagado*</mat-label>
                      <input matInput type="number" formControlName="MontoPagado" (keyup.enter)="onGuardar()">
                    </mat-form-field>
                  </div>

                </ng-container>

              </div>

            </mat-expansion-panel>

          </ng-container>

          <!-- CUENTA IMPUTADA PARA DEUDA -->
          <ng-container *ngIf="!(operacion > 0)">

            <br/>

            <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

              <mat-expansion-panel-header>
                <mat-panel-title class="card-subtitulo">
                  <mat-icon style="margin-top: -3px;">person_add</mat-icon> ¿A quién se le imputa el gasto?
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;" *ngIf="!esUnicaCuentaImputadaDisponible">
                  <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                    <button mat-raised-button (click)="openDialogCuentaDeudaSearch()" [disabled]="isProcessing()" color="primary" class="zb-button">
                      <mat-icon style="margin-right: 3px;">search</mat-icon>Asociar Cuenta a Deuda
                    </button>
                    <button mat-raised-button (click)="cleanCuentaDeuda()" *ngIf="cuentaImputada != null" [disabled]="isProcessing()"
                      style="margin-left: 3px;" color="warn" class="zb-button" title="Limpiar cuenta seleccionada">
                      <mat-icon style="margin-right: 3px;">delete_forever</mat-icon>
                    </button>
                  </div>

                </div>

                <ng-container *ngIf="cuentaImputada != null">

                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="cuentaImputada.Codigo != null && cuentaImputada.Codigo.length > 0">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label class="text-label"><b>Código </b>: {{cuentaImputada.Codigo}}</mat-label>
                      </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!(cuentaImputada.Codigo != null && cuentaImputada.Codigo.length > 0)">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label class="text-label">
                          <b>Código </b>:
                          <span *ngIf="cuentaImputada.PersonaNombre != null && cuentaImputada.PersonaNombre?.length > 0">{{cuentaImputada.PersonaNombre}} 1</span>
                          <span *ngIf="cuentaImputada.Proveedor != null && cuentaImputada.Proveedor?.length > 0">{{cuentaImputada.Proveedor}} </span>
                          <span *ngIf="cuentaImputada.Comunidad != null && cuentaImputada.Comunidad?.length > 0">{{cuentaImputada.Comunidad}} </span>
                          <span *ngIf="cuentaImputada.Consorcio != null && cuentaImputada.Consorcio?.length > 0">{{cuentaImputada.Consorcio}} </span>
                          <span *ngIf="cuentaImputada.UnidadFuncional != null && cuentaImputada.UnidadFuncional?.length > 0">{{cuentaImputada.UnidadFuncional}} 5</span>
                        </mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>

                  <ng-container *ngIf="!cuentaImputada.EsCuentaCorrienteInterna">

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-label"><b>CBU/CVU</b>: {{cuentaImputada.ClaveBancaria}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-label"><b>Alias</b>: {{cuentaImputada.Alias}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-label"><b>Banco</b>: {{cuentaImputada.BancoNombre}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>
                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-label"><b>Número de Cuenta</b>: {{cuentaImputada.NumeroCuenta}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                    <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                      <mat-expansion-panel [expanded]="true" hideToggle="true">
                        <div fxLayout="row stretch" fxLayout.xs="column">
                          <mat-label class="text-label"><b>Titular</b>: {{cuentaImputada.Titular}}</mat-label>
                        </div>
                      </mat-expansion-panel>
                    </div>

                  </ng-container>

                </ng-container>

              </div>

            </mat-expansion-panel>

          </ng-container>

          <br/>

          <!--DATOS DE CUENTA DETALLE-->
          <mat-expansion-panel [expanded]="false" style="margin-bottom: 1%;" *ngIf="!verVersionSimplificada">

            <mat-expansion-panel-header>
              <mat-panel-title class="card-subtitulo">
                <mat-icon style="margin-top: -3px;">send</mat-icon> {{operacion > 0 ? '¿De quién recibió el pago?' : '¿A quién se le envían los fondos?'}}
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">
              <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 10px;">
                <!-- <mat-expansion-panel [expanded]="true" hideToggle="true"> -->
                  <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                    <button mat-raised-button (click)="openDialogCuentaDetalleSearch()" [disabled]="isProcessing()" color="primary" class="zb-button">
                      <mat-icon style="margin-right: 3px;">search</mat-icon>Buscar Cuenta
                    </button>
                    <button mat-raised-button (click)="cleanCuentaDetalle()" *ngIf="cuentaDetalle != null" [disabled]="isProcessing()"
                      style="margin-left: 3px;" color="warn" class="zb-button" title="Limpiar cuenta seleccionada">
                      <mat-icon style="margin-right: 3px;">delete_forever</mat-icon>
                    </button>
                  </div>
                <!-- </mat-expansion-panel> -->
              </div>
            </div>

            <br/>

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <ng-container *ngIf="cuentaDetalle != null">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="cuentaDetalle.Codigo != null && cuentaDetalle.Codigo.length > 0">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label class="text-label"><b>Código </b>: {{cuentaDetalle.Codigo}}</mat-label>
                    </div>
                  </mat-expansion-panel>

                  <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!(cuentaDetalle.Codigo != null && cuentaDetalle.Codigo.length > 0)">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label class="text-label">
                        <b>Cuenta</b>:
                        <span *ngIf="cuentaDetalle.PersonaNombre != null && cuentaDetalle.PersonaNombre?.length > 0">{{cuentaDetalle.PersonaNombre}}</span>
                        <span *ngIf="cuentaDetalle.Proveedor != null && cuentaDetalle.Proveedor?.length > 0">{{cuentaDetalle.Proveedor}}</span>
                        <span *ngIf="cuentaDetalle.Comunidad != null && cuentaDetalle.Comunidad?.length > 0">{{cuentaDetalle.Comunidad}}</span>
                        <span *ngIf="cuentaDetalle.Consorcio != null && cuentaDetalle.Consorcio?.length > 0">{{cuentaDetalle.Consorcio}}</span>
                        <span *ngIf="cuentaDetalle.UnidadFuncional != null && cuentaDetalle.UnidadFuncional?.length > 0">{{cuentaDetalle.UnidadFuncional}}</span>
                      </mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

                <ng-container *ngIf="!cuentaDetalle.EsCuentaCorrienteInterna">

                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label class="text-label"><b>CBU/CVU</b>: {{cuentaDetalle.ClaveBancaria}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label class="text-label"><b>Alias</b>: {{cuentaDetalle.Alias}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>

                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label class="text-label"><b>Banco</b>: {{cuentaDetalle.BancoNombre}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label class="text-label"><b>Número de Cuenta</b>: {{cuentaDetalle.NumeroCuenta}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>

                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label class="text-label"><b>Titular</b>: {{cuentaDetalle.Titular}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>

                </ng-container>

              </ng-container>

            </div>

          </mat-expansion-panel>

        </form>

      </ng-container>

    </div>

  </mat-card-content>

  <mat-card-actions>
    <div fxLayout="row stretch" fxLayout.xs="column">
      <button mat-raised-button (click)="onGuardar()" *ngIf="canView && showStep1" [disabled]="isProcessing()" color="primary" class="zb-button">
        {{isSaving ? 'Guardando...' : 'Guardar'}}
      </button>
      <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">Cerrar</button>
    </div>
  </mat-card-actions>

</mat-card>
